import React from "react";
import { withRouter } from "react-router";
import { useTimeTrackingConfigs } from "../hooks/useTimeTrackingConfigs";
import TimeCategory from "./TimeCategory";
import styles from "../scss/TimeTrackingGroups.module.scss";
import { Button } from "../../../../shared/Button/Button";
import { SETTINGS_ROUTES } from "../../../../consts/routes";
import GroupsTable from "./GroupsTable";
import { PERMISSIONS } from "../../../../consts/api";
import { usePermission } from "../../../../hooks/usePermission";

const TimeTrackingConfigs = ({ history }) => {
  const { data } = useTimeTrackingConfigs();
  const goToCreateConfig = () => {
    history.push(SETTINGS_ROUTES.timeClock.createConfiguration());
  };

  const canViewTimeTrackingConfigs = usePermission(
    PERMISSIONS.settings.viewTimeTrackingConfigs,
  );

  const canEditTimeTrackingConfigs = usePermission(
    PERMISSIONS.settings.editTimeTrackingConfigs,
  );

  return canViewTimeTrackingConfigs?.permitted ? (
    <>
      <div>
        <h1 className={styles.title}>
          Configure Time Categories & Revenue Per Hour Report
        </h1>
        <p className={styles.paragraph}>
          Adding clock-in categories to account allows staff to more accurately
          track revenue-producing time versus time spent on other tasks.
        </p>
        <table className={styles.timeTrackingConfigsTable}>
          <thead>
            <tr>
              <th>Time Category</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data?.configs?.map((config, index) => (
              <TimeCategory
                key={config.id}
                id={config.id}
                name={config.display_name}
                isAvailable={config.is_available}
                isDefault={config.is_default}
                isLastRow={index === data.configs.length - 1}
                totalTrackedMinutes={config.total_tracked_minutes}
                canEditTimeTrackingConfigs={canEditTimeTrackingConfigs}
              />
            ))}
          </tbody>
        </table>
        {canEditTimeTrackingConfigs?.permitted && (
          <Button
            variant="text"
            leftAdornment={<span>+</span>}
            className={styles.addNewConfigButton}
            leftAdornmentClassName={styles.addornment}
            onClick={goToCreateConfig}
          >
            Configure Time Categories for Individuals & Groups
          </Button>
        )}
      </div>
      {data?.groups?.length > 0 && (
        <GroupsTable
          groups={data?.groups || []}
          canEditTimeTrackingConfigs={canEditTimeTrackingConfigs}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default withRouter(TimeTrackingConfigs);
